import { Flex } from "@chakra-ui/react";
import Table from "../components/Play/Table";
import { Navigate } from "react-router-dom";
import { useGameContext } from "../context/gameContext/gameContext";

const PlayGame = () => {
  const { settingsSubmitted } = useGameContext();
  if (!settingsSubmitted) {
    return <Navigate to="/play" />;
  }

  return (
    <Flex flex="1" direction="column" p={0} gap={5}>
      <Table />
    </Flex>
  );
};
export default PlayGame;
